import { render } from "./EditButton.vue?vue&type=template&id=db9f57ba&scoped=true"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=db9f57ba&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db9f57ba"]])

export default __exports__